import React from 'react';

function NotFoundPage() {
    return (
        <div>
            <h2>Not Found</h2>
        </div>
    )
}

export default NotFoundPage;